import { formatTimestampView } from '../utils/functions';


export const ContactingrecipeColumns = [
    /*{
        // aus den columns id entfernen, wenn sie nicht in der Tabelle erscheinen soll
        Header: 'Id', 
        accessor: 'id_contactingrecipe',
        disableFilters: true, // Filtermoeglichkeit für id entfernt
        sticky: 'left' // Spalte links fixieren
    },*/
    {
        Header: 'Bezeichnung',
        accessor: 'name',
        sticky: 'left' // Spalte links fixieren
    },
    {
        Header: 'Letzte Änderung',
        accessor: 'timestamp',
        /*Cell: ({ value }) => formatTimestampView(value),*/
        Cell: ({ value }) => formatTimestampView(value),
            sortType: (rowB, rowA) => {
            // Direktes Vergleichen der Timestamp-Werte für korrektes Sortieren
            const timestampA = rowA.values.timestamp;
            const timestampB = rowB.values.timestamp;

            return new Date(timestampB) - new Date(timestampA);
        }
    },
    {
        Header: 'Institution',
        accessor: 'institution_name', // wird nur in Tabelle angezeigt
    },
    {
        Header: 'Name Maschinenkonfiguration',
        accessor: 'machine_configuration_name', // dropdown
    },
    {
        Header: 'Produkt',
        accessor: 'product', // gehoert zum machine_configuration_name - wird nur in Tabelle angezeigt
    },
    {
        Header: 'Trägergarn',
        accessor: 'basic_yarn_name', // dropdown
    },
    {
        Header: 'Funktionsgarn 1',
        accessor: 'yarn_1_name', // dropdown
    },
    {
        Header: 'Funktionsgarn 2',
        accessor: 'yarn_2_name', // dropdown
    },
    {
        Header: 'Kontaktierungsmethode',
        accessor: 'contactingmethod_name', // dropdown
    },
    {
        Header: 'Vorhersage',
        accessor: 'prediction',
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },
    },
    {
        Header: 'Sonstige',
        accessor: 'others',
    },
]